export default function initializeExpanders() {
    const expanders = [...document.querySelectorAll('div.expander')]

    if (!expanders) {
        return
    }

    expanders.forEach(expander => {
        expander.querySelector('p.readmore').addEventListener('click', (e) => {
            handleClick(e)
        })
    })
}

function handleClick(e) {
    let x = e.target.parentElement.querySelector('div.expanding-text')
    if (x.classList.contains('open')) {
        e.target.classList.remove('open')
        x.classList.remove('open')
        x.style.removeProperty('height')
    } else {
        e.target.classList.add('open')
        x.classList.add('open')
        x.style.height = x.scrollHeight + 'px'
    }
}